import getLocal from '@/app/utils/getLocal';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';

const Output: React.FC = () => {
    const { locale } = getLocal();

    return (
        <div
            className={`${styles.Output} GtmModuleData-section`}
            id={'stream-ultra-x-Output'}
            data-section-id={'stream-ultra-x-Output'}
            data-section-title={'stream-ultra-x-Output'}
        >
            <div className="box ">
                <div className="content">
                    <EcoImg
                        pc={
                            locale === 'de'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1755163971112/22_de.png'
                                : 'https://websiteoss.ecoflow.com/upload/image/1755163499899/22.png'
                        }
                        h5={
                            locale === 'de'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1755163970929/22_de_M.png'
                                : 'https://websiteoss.ecoflow.com/upload/image/1755163499619/22_M.png'
                        }
                        isOpenLazy={true}
                    />
                </div>
            </div>
        </div>
    );
};

export default Output;
